import {
  ALL_PAYMENTS_QUERY_KEY,
  EDIT_GROUP_MUTATION,
  GROUP_ADMIN_QUERY_KEY,
  GROUP_QUERY_KEY,
  REMOVE_GROUP_MUTATION,
  apiRoutes,
  queryClient
} from "@data/lib";
import { useGroupStore } from "@mod/groups";
import { Group } from "@mod/groups/types";
import { useParams } from "react-router-dom";
import { useApi } from "./api";
import { NewGroupResponse, PaymentHistoryItem, RemoveGroupResponse } from "./types";

export const groupZones = [
  { id: "CENTRAL" },
  { id: "PARACENTRAL" },
  { id: "ORIENTAL" },
  { id: "OCCIDENTAL_SANTA_ANA" },
  { id: "OCCIDENTAL_SONSONATE" }
];

export const useGroupsAdmin = () => {
  const { data, isFetching, isLoading } = useApi(GROUP_ADMIN_QUERY_KEY).useSecuredApiCall<Group[]>({
    url: apiRoutes.groupListAll
  });
  return { groupsList: data?.data ?? [], isFetching, isLoading };
};

export const useGroups = () => {
  const params = useParams();

  const { data, isFetching, isLoading } = useApi(GROUP_QUERY_KEY).useSecuredApiCall<Group[]>({
    url: apiRoutes.groupList
  });

  const currentGroup = data?.data?.find((group) => group.id === params.id);
  return { groupsList: data, isFetching, isLoading, currentGroup };
};

export const useEditGroup = () => {
  const {
    mutateAsync: editGroup,
    isPending: loadingEditGroup,
    data: responseEditGroup
  } = useApi(EDIT_GROUP_MUTATION).useApiMutation<NewGroupResponse>({
    url: apiRoutes.groupUpdateGroup,
    method: "PUT",
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GROUP_QUERY_KEY]
      });
    }
  });

  const {
    mutateAsync: removeGroup,
    isPending: loadingRemoveGroup,
    data: responseRemoveGroup
  } = useApi(REMOVE_GROUP_MUTATION).useApiMutation<RemoveGroupResponse>({
    url: apiRoutes.groupRemove,
    method: "DELETE",
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GROUP_QUERY_KEY]
      });
    }
  });

  return {
    editGroup,
    removeGroup,
    loading: loadingEditGroup || loadingRemoveGroup,
    response: responseEditGroup || responseRemoveGroup,
    error: responseEditGroup?.error ?? responseRemoveGroup?.error ?? null
  };
};

export const useAllPaymentsList = () => {
  const { startDate } = useGroupStore();

  const { data, isFetching } = useApi(ALL_PAYMENTS_QUERY_KEY).useSecuredApiCall<PaymentHistoryItem[]>({
    url: apiRoutes.groupListAllPayments(startDate ?? ""),
    enabled: !!startDate,
    method: "GET",
    keys: {
      startDate
    }
  });

  return { allPaymentsList: data?.data ?? [], isFetching };
};
